import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Flame } from "lucide-react";

export default function FoundersScoreboard() {
  const [data, setData] = useState(null);
  useEffect(() => {
    let cancelled = false;
    const fetchOnce = () => api.get("/launch/founding-count")
      .then(r => { if (!cancelled) setData(r.data); })
      .catch(() => {});
    fetchOnce();
    // Live-poll every 30s so a new signup ticks the counter up
    // (70 → 71 → 72 …) without requiring a page reload.
    const id = setInterval(fetchOnce, 30000);
    // Also refresh whenever the tab regains focus (returning from Stripe).
    const onFocus = () => fetchOnce();
    window.addEventListener("focus", onFocus);
    return () => {
      cancelled = true;
      clearInterval(id);
      window.removeEventListener("focus", onFocus);
    };
  }, []);
  if (!data) return null;
  const pct = data.pct_filled || 0;
  const remaining = data.remaining || 0;
  const claimed = data.count || 0;

  return (
    <Link
      to="/pricing"
      data-testid="founders-scoreboard"
      className="mt-8 inline-flex flex-col gap-2 bg-white/70 backdrop-blur-md border border-[var(--ff-border)] hover:border-[var(--ff-primary)] rounded-2xl px-5 py-4 transition-all max-w-md group shadow-sm"
    >
      <div className="flex items-center justify-between gap-6">
        <div className="flex items-center gap-2">
          <Flame size={14} className="text-[var(--ff-citrus)]"/>
          <span className="text-[10px] font-semibold uppercase tracking-[0.18em] text-[var(--ff-citrus)]">
            Founding members · live
          </span>
        </div>
        <span className="text-xs text-[var(--ff-text-secondary)] group-hover:text-[var(--ff-primary)] transition-colors">
          Claim yours →
        </span>
      </div>

      <div className="flex items-baseline gap-3">
        <span className="font-display text-3xl text-[var(--ff-primary)]" data-testid="founders-count">
          {claimed}
        </span>
        <span className="text-[var(--ff-text-secondary)] text-sm">/ {data.cap} claimed</span>
        {!data.is_full && (
          <span className="ml-auto text-[var(--ff-citrus)] text-xs font-semibold uppercase tracking-wider" data-testid="founders-remaining">
            {remaining} left
          </span>
        )}
        {data.is_full && (
          <span className="ml-auto text-[var(--ff-text-secondary)] text-xs font-semibold uppercase tracking-wider">
            Waitlist open
          </span>
        )}
      </div>

      <div className="h-1.5 w-full bg-[var(--ff-muted)] rounded-full overflow-hidden">
        <div
          className="h-full bg-[var(--ff-citrus)] rounded-full transition-all duration-1000"
          style={{ width: `${Math.max(pct, 2)}%` }}
          data-testid="founders-progress"
        />
      </div>
    </Link>
  );
}
